<template>
  <div id="app">
    <div class="main-container">
      <!-- 侧边栏：登录页或设置了 meta.hideSidebar 时不显示 -->
      <SidebarMenu v-if="showSidebar" ref="sidebarRef" @collapseChange="handleSidebarCollapse"></SidebarMenu>
      <!-- 主内容区域 -->
      <div class="content-container">
        <!-- 顶部导航栏：登录页或设置了 meta.hideSidebar 时不显示 -->
        <div class="top-navbar" v-if="showTopbar">
          <div class="navbar-left">
            <el-button v-if="isMobile" type="text" icon="el-icon-menu" @click="toggleSidebar"
              class="menu-toggle-btn"></el-button>
            <span class="breadcrumb">{{ pageTitle }}</span>
          </div>
          <div class="navbar-right">
            <el-dropdown trigger="click">
              <span class="user-info">
                <i class="el-icon-user-solid"></i>
                <span class="username">管理员</span>
                <i class="el-icon-arrow-down"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleProfile">个人中心</el-dropdown-item>
                <el-dropdown-item @click.native="handlePassword">修改密码</el-dropdown-item>
                <el-dropdown-item divided @click.native="handleLogout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <!-- 内容区（路由渲染） -->
        <div class="page-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarMenu from '@/components/Sidebar.vue'
// 引入认证工具函数
import { removeToken } from '@/utils/auth'

export default {
  name: 'App',
  components: { SidebarMenu },
  data() {
    return {
      isMobile: false,
      sidebarCollapsed: false // 侧边栏收缩状态
    }
  },
  computed: {
    showSidebar() {
      // 在登录页不显示侧边栏；同时支持通过路由元信息控制（route.meta.hideSidebar）
      const route = this.$route || {}
      const path = route.path || ''
      const meta = route.meta || {}
      if (meta.hideSidebar) return false
      return path !== '/login'
    }
    ,
    // 顶部导航栏是否显示（与侧边栏保持一致，可单独调整）
    showTopbar() {
      const route = this.$route || {}
      const meta = route.meta || {}
      if (meta.hideSidebar) return false
      return (route.path || '') !== '/login'
    },
    // 动态页面标题
    pageTitle() {
      const route = this.$route || {}
      const path = route.path || ''

      // 根据路径返回对应的页面标题
      const titleMap = {
        '/index': '首页',
        '/company': '公司管理',
        '/account': '账户管理',
        '/account/record': '账户记录详情',
        '/order/flight': '飞机票订单',
        '/order/hotel': '酒店订单',
        '/order/train': '火车票订单',
        '/order/meituan': '美团订单',
        '/order/jingdong': '京东订单',
        '/system/user': '用户管理',
        '/system/role': '角色管理',
        '/system/menu': '菜单管理'
      }

      return titleMap[path] || '首页'
    }
  },
  mounted() {
    this.checkIsMobile()
    window.addEventListener('resize', this.checkIsMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile)
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    toggleSidebar() {
      if (this.$refs.sidebarRef) this.$refs.sidebarRef.toggleSidebar()
    },
    handleProfile() { console.log('打开个人中心') },
    handlePassword() { console.log('打开修改密码') },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除token
        removeToken()

        // 显示成功消息
        this.$message.success('退出登录成功')

        // 延迟重定向到登录页，确保消息能显示
        setTimeout(() => {
          try {
            if (this.$router) {
              this.$router.push('/login')
            } else {
              window.location.href = '/#/login'
            }
          } catch (error) {
            console.error('重定向失败:', error)
          }
        }, 1000)
      }).catch(() => {
        this.$message.info('已取消退出')
      })
    },
    // 处理侧边栏收缩状态变化
    handleSidebarCollapse(collapsed) {
      this.sidebarCollapsed = collapsed
    }
  }
}
</script>
<style>
body {
  margin: 0 !important;
}
</style>
<style scoped>
/* 基础样式（来自 index 页面，控制侧边栏与内容布局） */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.main-container {
  display: flex;
  min-height: 100vh;
  position: relative;
  background-color: #f5f7fa;
}

:deep(.sidebar-container) {
  width: 260px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

:deep(.sidebar-container) .el-menu--collapse {
  width: 64px;
}

.content-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.top-navbar {
  height: 64px;
  background: linear-gradient(90deg, #fff, #f9fafb);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  z-index: 10;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.navbar-left {
  display: flex;
  align-items: center;
  gap: 16px
}

.menu-toggle-btn {
  margin-right: 8px;
  display: none;
  color: #606266
}

.menu-toggle-btn:hover {
  color: #409EFF;
  transform: scale(1.05)
}

.breadcrumb {
  font-size: 16px;
  color: #303133;
  font-weight: 600
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 16px
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.user-info:hover {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 下拉菜单样式 */
:deep(.el-dropdown-menu) {
  background-color: #fff !important;
  border: 1px solid #dcdfe6 !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  border-radius: 4px !important;
}

:deep(.el-dropdown-menu__item) {
  color: #606266 !important;
  padding: 10px 20px !important;
  margin: 0 !important;
}

:deep(.el-dropdown-menu__item:hover) {
  background-color: #ecf5ff !important;
  color: #409eff !important;
}

:deep(.el-dropdown-menu__item.divided) {
  border-top: 1px solid #ebeef5 !important;
  margin-top: 5px !important;
  padding-top: 15px !important;
}

.page-content {
  flex: 1;
  /* padding: 0 24px; */
  overflow-y: auto;
  animation: fadeIn 0.6s ease-out
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px)
  }

  to {
    opacity: 1;
    transform: translateY(0)
  }
}

.welcome-card {
  max-width: 900px;
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 56px;
  background: linear-gradient(90deg, #f0f9ff, #e0f7fa);
  border-bottom: 1px solid rgba(64, 158, 255, 0.2);
}

.card-body {
  text-align: center;
  padding: 60px 40px;
  position: relative
}

.card-body h1 {
  color: #2c3e50;
  margin-bottom: 24px;
  font-size: 32px;
  font-weight: 700
}

@media (max-width:768px) {
  .menu-toggle-btn {
    display: inline-block
  }

  .top-navbar {
    padding: 0 16px;
    height: 56px
  }

  .breadcrumb {
    font-size: 14px
  }

  ::v-deep .page-content {
    padding: 0 !important;
  }
}
</style>
